import { render, staticRenderFns } from "./weekSelect.vue?vue&type=template&id=582fce91&scoped=true&"
import script from "./weekSelect.vue?vue&type=script&lang=js&"
export * from "./weekSelect.vue?vue&type=script&lang=js&"
import style0 from "./weekSelect.vue?vue&type=style&index=0&id=582fce91&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582fce91",
  null
  
)

export default component.exports